import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Required so dayjs can parse our stored "HH:mm" / "YYYY-MM-DD" strings with an explicit
// format (the MUI X TimePicker/DatePicker round-trip through these). Without it, format-string
// parsing is ignored and "12:30" becomes Invalid Date.
dayjs.extend(customParseFormat);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
